import { cn as e } from "../utils/index.js";
import { Toggle as t } from "./toggle.js";
import "../index.js";
import { jsx as n } from "react/jsx-runtime";
//#region src/components/tag.tsx
var r = {
	toggle: "hover:*:[span]:bg-(--seafoam-50) hover:data-[state=on]:*:[span]:bg-(--seafoam-50) hover:text-(--neutral-500) hover:bg-(--seafoam-50)",
	text: "",
	highlight: ""
}, i = {
	toggle: "data-[state=on]:border-white data-[state=on]:bg-grad data-[state=on]:*:[span]:text-(--seafoam-600) data-[state=on]:*:[span]:bg-white data-[state=on]:*:[span]:font-medium data-[state=on]:*:[span]:rounded-[5px]",
	text: "",
	highlight: "bg-white border border-(--seafoam-500) text-(--seafoam-500) "
}, a = {
	xs: "font-short-14 font-medium text-(--neutral-900)",
	sm: "font-reg-12",
	lg: "font-short-14"
}, o = ({ children: o, onToggle: s, disabled: c = !1, size: l = "lg", variant: u = "text", pressed: d = !1, defaultPressed: f }) => /* @__PURE__ */ n(t, {
	size: "sm",
	onPressedChange: s,
	defaultPressed: f,
	disabled: c,
	pressed: d,
	className: e("h-6 inline-flex items-center rounded-sm justify-center border-(--neutral-50) bg-(--neutral-50) text-(--neutral-500) p-px m-1 ml-0 mr-2", r[u], i[u]),
	children: /* @__PURE__ */ n("span", {
		className: `font-normal p-0.75 px-2 w-full ${a[l]}`,
		children: o
	})
});
//#endregion
export { o as Tag };
